/**
 * Detects a failed dynamic `import()` of a route chunk.
 *
 * With route-level code splitting this is a normal operational failure, not a
 * bug: after a redeploy the hashed chunk an open tab points to no longer
 * exists, and the browser reports it with one of a handful of vendor-specific
 * messages. It must be distinguished from a real render error, because the fix
 * differs — a stale chunk is cured by reloading the document, a render bug is
 * not.
 */

const PATTERNS = [
  /Loading chunk \d+ failed/i, // webpack-style, also emitted by some browsers
  /Failed to fetch dynamically imported module/i, // Chrome / Edge
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
];

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : typeof error === "string"
        ? error
        : "";
  if (!message) return false;
  return PATTERNS.some((re) => re.test(message));
}
